var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elementsHeadlinePreview"},[_c('div',{staticClass:"question-text headline",class:_vm.propsObj.selectedHeadlineProp,style:({'color': _vm.propsObj.color}),attrs:{"id":'headlineTextPreview' + _vm.propsObj.id,"align-items-start":"","align-self-start":""}},[_vm._v(" "+_vm._s(_vm.replaceReferences(_vm.translation))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }